// Move by identity so hidden widgets remain available and cannot be duplicated.
export function overviewDragPosition(box,listTop,startScroll,scroll,fingerDelta) {
  return {overlayTop:listTop+box.y-startScroll+fingerDelta,center:box.y+box.height/2+fingerDelta+scroll-startScroll};
}
export function moveOverviewWidget(widgets, id, targetIndex) {
  const visible = widgets.filter(w => w.visible), from = visible.findIndex(w => w.id === id);
  if (from < 0 || !Number.isInteger(targetIndex)) return widgets;
  const target = Math.max(0, Math.min(visible.length - 1, targetIndex));
  visible.splice(target, 0, ...visible.splice(from, 1));
  return [...visible, ...widgets.filter(w => !w.visible)];
}
export function overviewDropIndex(layouts, id, center) {
  const others = layouts.filter(w => w.id !== id);
  return others.filter(w => center > w.y + w.height / 2).length;
}
// Keep the gesture's native view mounted in its original slot. Move its neighbours
// to their new slots visually; committing on release cannot interrupt the gesture.
export function overviewDragOffsets(layouts, id, targetIndex) {
  const from=layouts.findIndex(box=>box.id===id);
  if(from<0 || !Number.isInteger(targetIndex)) return {};
  const ordered=[...layouts], target=Math.max(0,Math.min(layouts.length-1,targetIndex));
  const gap=layouts.length>1?Math.max(0,layouts[1].y-layouts[0].y-layouts[0].height):0;
  ordered.splice(target,0,...ordered.splice(from,1));
  let y=layouts[0].y;
  return Object.fromEntries(ordered.map(box=>{const shift=y-box.y;y+=box.height+gap;return [box.id,shift];}));
}
export function hideOverviewWidget(widgets, id) {
  if (widgets.filter(w => w.visible).length <= 1) return widgets;
  return widgets.map(w => w.id === id ? { ...w, visible: false } : w);
}
export function showOverviewWidget(widgets, id) {
  const item = widgets.find(w => w.id === id);
  if (!item || item.visible) return widgets;
  return [...widgets.filter(w => w.visible), { ...item, visible: true }, ...widgets.filter(w => !w.visible && w.id !== id)];
}
// Dashboard preferences belong to the account. Editing a GPS view must not
// erase health/activity cards used by another registered personal alarm.
export function mergeDeviceOverviewWidgets(original,edited){
 const ids=new Set(edited.map(w=>w.id)),queue=[...edited];
 return [...original.map(w=>ids.has(w.id)?queue.shift():w),...queue];
}

// Pack in reading order; do not backfill holes or change stored span choices.
export function overviewGridSlots(layouts,width,gap){
 let x=0,y=0,rowHeight=0;
 return layouts.map(box=>{
  if(x>0&&x+box.width>width+.5){x=0;y+=rowHeight+gap;rowHeight=0;}
  const slot={...box,x,y};x+=box.width+gap;rowHeight=Math.max(rowHeight,box.height);return slot;
 });
}
export function overviewGridDropIndex(layouts,id,x,y){
 const from=layouts.findIndex(b=>b.id===id);if(from<0)return 0;
 if(y<Math.min(...layouts.map(b=>b.y)))return 0;
 if(y>Math.max(...layouts.map(b=>b.y+b.height)))return layouts.length-1;
 const columns=new Set(layouts.map(b=>Math.round(b.x))).size;
 if(columns<=1)return overviewDropIndex(layouts,id,y);
 const distance=b=>Math.hypot(Math.max(b.x-x,0,x-b.x-b.width),Math.max(b.y-y,0,y-b.y-b.height));
 const nearest=layouts.reduce((best,b)=>distance(b)<distance(best)?b:best,layouts[0]),index=layouts.indexOf(nearest);
 // A row occupied by one card must remain movable with a vertical drag from
 // its left-aligned handle, even when other rows contain several columns.
 const aloneInRow=layouts.filter(b=>Math.abs(b.y-nearest.y)<1).length===1;
 const after=aloneInRow?y>nearest.y+nearest.height/2:x>nearest.x+nearest.width/2;
 const boundary=index+(after?1:0);
 return Math.max(0,Math.min(layouts.length-1,boundary-(from<boundary?1:0)));
}
